<hr>
<footer id="app-footer" class="p-grid" *ngIf="globals.tokenDataLoaded()">
	<div class="p-col footer-container">
		<p class="text-center" i18n="@@copyright">
			{{actualYear}} © Ford Motor Company
		</p>
	</div>
</footer>
